<section class="so-einfach-section position-relative py-5">
    <div class="container">
        <h2 class="section-title mb-5 text-center fw-bold">
            So einfach funktioniert es
        </h2>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <ul class="timeline list-unstyled position-relative">
                    <!-- Step 1 -->
                    <li class="timeline-item d-flex align-items-start mb-5">
                        <span class="timeline-icon flex-shrink-0 shadow-sm">
                            <i class="fa-solid fa-list-check"></i>
                        </span>
                        <div class="timeline-content ms-4">
                            <h5 class="fw-semibold mb-1">Listen zusammenstellen</h5>
                            <p class="mb-0 text-muted">Wählen Sie die gewünschten Datenkategorien und Filter.</p>
                        </div>
                    </li>
                    <!-- Step 2 -->
                    <li class="timeline-item d-flex align-items-start mb-5">
                        <span class="timeline-icon flex-shrink-0 shadow-sm">
                            <i class="fa-solid fa-table-columns"></i>
                        </span>
                        <div class="timeline-content ms-4">
                            <h5 class="fw-semibold mb-1">Datei konfigurieren</h5>
                            <p class="mb-0 text-muted">Entscheiden Sie selbst, welche Spalten Ihre Datei enthalten soll.</p>
                        </div>
                    </li>
                    <!-- Step 3 -->
                    <li class="timeline-item d-flex align-items-start mb-5">
                        <span class="timeline-icon flex-shrink-0 shadow-sm">
                            <i class="fa-solid fa-credit-card"></i>
                        </span>
                        <div class="timeline-content ms-4">
                            <h5 class="fw-semibold mb-1">Bequem bezahlen</h5>
                            <p class="mb-0 text-muted">Sie zahlen unkompliziert per Banküberweisung oder PayPal.</p>
                        </div>
                    </li>
                    <!-- Step 4 -->
                    <li class="timeline-item d-flex align-items-start">
                        <span class="timeline-icon flex-shrink-0 shadow-sm">
                            <i class="fa-solid fa-rocket"></i>
                        </span>
                        <div class="timeline-content ms-4">
                            <h5 class="fw-semibold mb-1">Daten nutzen</h5>
                            <p class="mb-0 text-muted">Starten Sie direkt mit Ihrer Kampagne, ohne Umwege.</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
